import { render, staticRenderFns } from "./problemAppeal.vue?vue&type=template&id=666d983a&scoped=true"
import script from "./problemAppeal.vue?vue&type=script&lang=js"
export * from "./problemAppeal.vue?vue&type=script&lang=js"
import style0 from "./problemAppeal.vue?vue&type=style&index=0&id=666d983a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d983a",
  null
  
)

export default component.exports